// src/storeVisits/geo.js — geotag a store-visit report at submit time.
//
// captureGeo() asks the browser for the device location (which shows the native
// permission prompt the first time). It is deliberately FORGIVING: it never throws and
// never blocks the submit — if the AM denies permission, the device has no GPS, or it
// times out, it resolves to null and the report submits without coordinates. There is no
// geofence: we only RECORD where the report was completed (which may legitimately be away
// from the store), we never reject a submission based on location.

// Returns { lat, lng, accuracy } (accuracy in metres) or null. Always resolves.
export function captureGeo(timeoutMs) {
  return new Promise(function (resolve) {
    try {
      if (typeof navigator === 'undefined' || !navigator.geolocation) {
        resolve(null);
        return;
      }
      var settled = false;
      var done = function (v) { if (!settled) { settled = true; resolve(v); } };
      // Hard cap so a hanging GPS lookup can never stall the submit.
      var t = setTimeout(function () { done(null); }, timeoutMs || 8000);
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          clearTimeout(t);
          var c = (pos && pos.coords) || {};
          if (typeof c.latitude === 'number' && typeof c.longitude === 'number') {
            done({ lat: c.latitude, lng: c.longitude, accuracy: (typeof c.accuracy === 'number' ? c.accuracy : null) });
          } else {
            done(null);
          }
        },
        function () { clearTimeout(t); done(null); },   // denied / unavailable — submit anyway
        { enableHighAccuracy: true, timeout: timeoutMs || 8000, maximumAge: 60000 }
      );
    } catch (e) {
      resolve(null);
    }
  });
}

// Merge a captured geo reading into a submit payload (no-op when geo is null).
export function geoFields(geo) {
  if (!geo) return {};
  return {
    geo_lat: geo.lat,
    geo_lng: geo.lng,
    geo_accuracy: (typeof geo.accuracy === 'number' ? geo.accuracy : null),
    geo_captured_at: new Date().toISOString(),
  };
}
